import React, { useState } from 'react'
import {
  CButton,
  CCol,
  CFormLabel,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import { changedEndedStatusMounted } from './model'
import { changeDemoContestStatusMounted } from '../../details/model'
import { DemoContestItem, DemoContestStatuses } from '../../details/types'

type Props = {
  demoContest: DemoContestItem
  isVisible: boolean
  onClose: () => void
}

export const ChangedEndedStatusModal: React.FC<Props> = ({
  demoContest,
  isVisible,
  onClose,
}) => {
  const [teamData, setTeamData] = useState('first')

  const handleSubmit = () => {
    // Выполнение первой функции
    changedEndedStatusMounted({ winnerTeam: teamData })
    setTimeout(() => {
      changeDemoContestStatusMounted({
        id: String(demoContest.id),
        status:
          DemoContestStatuses[
            demoContest.status as keyof typeof DemoContestStatuses
          ],
      })
      onClose()
    }, 1000)
  }

  return (
    <CModal visible={isVisible} onClose={onClose} size={'lg'}>
      <CModalHeader>
        <CModalTitle>Set team</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow>
          <CCol xs={8}>
            <div className="mb-4">
              <CFormLabel className="fw-bold">Choose the team</CFormLabel>
              <CFormSelect
                name="teamData"
                placeholder="Team"
                value={teamData}
                onChange={(e) => {
                  setTeamData(e.target.value)
                }}
              >
                <option value="first">First</option>
                <option value="second">Second</option>
              </CFormSelect>
            </div>
          </CCol>
        </CRow>
        <CModalFooter>
          <CButton
            color="secondary"
            onClick={() => {
              onClose()
              setTeamData('')
            }}
          >
            Cancel
          </CButton>
          <CButton color="primary" className="px-4" onClick={handleSubmit}>
            Ok
          </CButton>
        </CModalFooter>
      </CModalBody>
    </CModal>
  )
}
